import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Skeleton } from '@grandvisionhq/iris-ui';

const LoadingIndication = ()=>/*#__PURE__*/ React.createElement("div", {
        className: "loading-indication"
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        height: "100%",
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        fill: "currentColor",
        y: "0",
        height: "100%"
    })))
;
const LoadingStoreCard = (_param)=> {
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('loading-store-card', className)
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: "first-row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "first-row__left"
    }, /*#__PURE__*/ React.createElement(LoadingIndication, null)), /*#__PURE__*/ React.createElement("div", {
        className: "first-row__right"
    }, /*#__PURE__*/ React.createElement(LoadingIndication, null))), /*#__PURE__*/ React.createElement("div", {
        className: "second-row"
    }, /*#__PURE__*/ React.createElement(LoadingIndication, null)), /*#__PURE__*/ React.createElement("div", {
        className: "third-row"
    }, /*#__PURE__*/ React.createElement(LoadingIndication, null)));
};

export { LoadingStoreCard as default };
//# sourceMappingURL=LoadingStoreCard.js.map
